import React from 'react'
import { Navigate, Route } from 'react-router-dom';
import { all_routes } from './all_routes';

//auth - start
import Change_Password from '../auth/change-password';
import Forgot_Password from '../auth/forgot-password';
import Login from '../auth/login';
import Register from '../auth/register';
//auth - end

//page - start
import About from '../about';
import Contact from '../contact';
import Home from '../home';
import Faq from '../faq/';
import Review from '../review';
import Review_Edit from '../review/edit';
//page - end

//app - start
import Product_App from '../product_app';
import Product_App_Detail from '../product_app/detail';
import Product_App_CheckOut from '../product_app/checkout';
import Product_App_CheckOut_Success from '../product_app/checkout-success';
import Product_App_Payment_Success from '../product_app/payment-success';
//app - end

// -- gallery --
import Gallery from '../gallery';
import Gallery_Detail from '../gallery/detail';

// -- team --
import Team from '../team';
import Team_Detail from '../team/detail';

//blog_post - start
import Blog_Post from '../blog_post';
import Blog_Post_Detail from '../blog_post/detail';
//blog_post - end

//dashboard-user - start
//import Dashboard_User_Stat from '../dashboard/user/stat';
import Dashboard_User_App from '../dashboard/user/app';
import Dashboard_User_App_Detail from '../dashboard/user/app/detail';
import Dashboard_User_Favorite from '../dashboard/user/favorite';
import Dashboard_User_Home from '../dashboard/user/home';
import Dashboard_User_Order from '../dashboard/user/order';
import Dashboard_User_Order_Detail from '../dashboard/user/order/detail';
import Dashboard_User_Profile_Detail from '../dashboard/user/profile/detail';
import Dashboard_User_Profile_Edit from '../dashboard/user/profile/edit';
import Dashboard_User_Review from '../dashboard/user/review';
import Dashboard_User_Support from '../dashboard/user/support';
//dashboard-user - end

//dashboard-admin - start
import Dashboard_Admin_App from '../dashboard/admin/app';
import Dashboard_Admin_App_Detail from '../dashboard/admin/app/detail';
import Dashboard_Admin_Cart from '../dashboard/admin/cart';
import Dashboard_Admin_Cart_Detail from '../dashboard/admin/cart/detail';
import Dashboard_Admin_Favorite from '../dashboard/admin/favorite';
import Dashboard_Admin_Home from '../dashboard/admin/home';
import Dashboard_Admin_User from '../dashboard/admin/user';
import Dashboard_Admin_User_Detail from '../dashboard/admin/user/detail';
import Dashboard_Admin_User_Edit from '../dashboard/admin/user/edit';
import Dashboard_Admin_Order from '../dashboard/admin/order';
import Dashboard_Admin_Order_Detail from '../dashboard/admin/order/detail';
import Dashboard_Admin_Review from '../dashboard/admin/review';
import Dashboard_Admin_Stat from '../dashboard/admin/stat';
//dashboard-admin - end

//dashboard-app - start
import Dashboard_App_Blog_Post from '../dashboard/app/blog_post';
import Dashboard_App_Blog_Post_Edit from '../dashboard/app/blog_post/edit';
import Dashboard_App_Category from '../dashboard/app/category';
import Dashboard_App_Category_Edit from '../dashboard/app/category/edit';
import Dashboard_App_Content from '../dashboard/app/content';
import Dashboard_App_Content_Edit from '../dashboard/app/content/edit';
import Dashboard_App_Custom_Field from '../dashboard/app/custom_field';
import Dashboard_App_Custom_Field_Edit from '../dashboard/app/custom_field/edit';
import Dashboard_App_Event from '../dashboard/app/event';
import Dashboard_App_Event_Edit from '../dashboard/app/event/edit';
import Dashboard_App_Faq from '../dashboard/app/faq';
import Dashboard_App_Faq_Edit from '../dashboard/app/faq/edit';
import Dashboard_App_Gallery from '../dashboard/app/gallery';
import Dashboard_App_Gallery_Edit from '../dashboard/app/gallery/edit';
import Dashboard_App_Home from '../dashboard/app/home';
import Dashboard_App_Sub_Value_Edit_Pop_Open from '../dashboard/app/sub_value/edit/pop_open_window';
import Dashboard_App_Order from '../dashboard/app/order';
import Dashboard_App_Order_Detail from '../dashboard/app/order/detail';
import Dashboard_App_Order_Edit from '../dashboard/app/order/edit';
import Dashboard_App_Page from '../dashboard/app/page';
import Dashboard_App_Page_Edit from '../dashboard/app/page/edit';
import Dashboard_App_Product from '../dashboard/app/product';
import Dashboard_App_Product_Edit from '../dashboard/app/product/edit';
import Dashboard_App_Review from '../dashboard/app/review';
import Dashboard_App_Service from '../dashboard/app/service';
import Dashboard_App_Service_Edit from '../dashboard/app/service/edit';
import Dashboard_App_Template from '../dashboard/app/template';
import Dashboard_App_Template_Edit from '../dashboard/app/template/edit';
import Dashboard_App_Type from '../dashboard/app/type';
import Dashboard_App_Type_Edit from '../dashboard/app/type/edit';
import Dashboard_App_User from '../dashboard/app/user';
import Dashboard_App_User_Edit from '../dashboard/app/user/edit';
//dashboard-app - end

const routes = all_routes;

export const public_routes = [
{
path: "/",
          exact: true,
          element: <Navigate to={routes.home} />, // Redirect to the home route
},

//pages - start
{
path: routes.about,
      element: <About />,
      route: Route,
},
{
path: routes.product_app,
      element: <Product_App/>,
      route: Route,
},
{
path: routes.product_app_checkout,
      element: <Product_App_CheckOut/>,
      route: Route,
},
{
path: routes.product_app_checkout_success,
      element: <Product_App_CheckOut_Success/>,
      route: Route,
},
{
path: routes.product_app_payment_success,
      element: <Product_App_Payment_Success/>,
      route: Route,
},
{
path: routes.product_app_detail,
      element: <Product_App_Detail/>,
      route: Route,
},
{
path: routes.blog_post,
      element: <Blog_Post />,
      route: Route,
},
{
path: routes.blog_post_detail,
      element: <Blog_Post_Detail />,
      route: Route,
},
{
path: routes.contact,
      element: <Contact />,
      route: Route,
},
{
path: routes.gallery,
      element: <Gallery />,
      route: Route,
},
{
path: routes.gallery_detail,
      element: <Gallery_Detail />,
      route: Route,
},
{
path: routes.team,
      element: <Team />,
      route: Route,
},
{
path: routes.team_detail,
      element: <Team_Detail />,
      route: Route,
},
{
path: routes.faq,
      element: <Faq />,
      route: Route,
},
{
path: routes.home,
      element: <Home />,
      route: Route,
},
{
path: routes.review,
      element: <Review />,
      route: Route,
},
{
path: routes.review_edit,
      element: <Review_Edit />,
      route: Route,
},
//pages - end
];

// auth - start

export const auth_routes = [
{
path: routes.login,
          element: <Login />,
          route: Route,
},
{
path: routes.register,
      element: <Register />,
      route: Route,
},
{
path: routes.forgot_password,
      element: <Forgot_Password />,
      route: Route,
},
{
path: routes.change_password,
      element: <Change_Password />,
      route: Route,
},

]
// auth - end

export const dashboard_routes = [
// dashboard-app - start

{
path: routes.dashboard_app_blog_post,
      element: <Dashboard_App_Blog_Post />,
      route: Route,
},
{
path: routes.dashboard_app_blog_post_edit,
      element: <Dashboard_App_Blog_Post_Edit />,
      route: Route,
},
{
path: routes.dashboard_app_category,
      element: <Dashboard_App_Category />,
      route: Route,
},
{
path: routes.dashboard_app_category_edit,
      element: <Dashboard_App_Category_Edit />,
      route: Route,
},
{
path: routes.dashboard_app_custom_field,
      element: <Dashboard_App_Custom_Field />,
      route: Route,
},
{
path: routes.dashboard_app_custom_field_edit,
      element: <Dashboard_App_Custom_Field_Edit />,
      route: Route,
},
{
path: routes.dashboard_app_content,
      element: <Dashboard_App_Content />,
      route: Route,
},
{
path: routes.dashboard_app_content_edit,
      element: <Dashboard_App_Content_Edit />,
      route: Route,
},
{
path: routes.dashboard_app_faq_edit,
      element: <Dashboard_App_Faq_Edit />,
      route: Route,
},
{
path: routes.dashboard_app_event,
      element: <Dashboard_App_Event />,
      route: Route,
},
{
path: routes.dashboard_app_event_edit,
      element: <Dashboard_App_Event_Edit />,
      route: Route,
},

{
path: routes.dashboard_app_faq,
      element: <Dashboard_App_Faq />,
      route: Route,
},
{
path: routes.dashboard_app_gallery,
      element: <Dashboard_App_Gallery />,
      route: Route,
},
{
path: routes.dashboard_app_gallery_edit,
      element: <Dashboard_App_Gallery_Edit />,
      route: Route,
},
{
path: routes.dashboard_app_home,
      element: <Dashboard_App_Home />,
      route: Route,
},
{
path: routes.dashboard_app_sub_value_edit_pop_open,
      element: <Dashboard_App_Sub_Value_Edit_Pop_Open />,
      route: Route,
},
{
path: routes.dashboard_app_user,
      element: <Dashboard_App_User />,
      route: Route,
},
{
path: routes.dashboard_app_user_edit,
      element: <Dashboard_App_User_Edit />,
      route: Route,
},
{
path: routes.dashboard_app_order,
      element: <Dashboard_App_Order />,
      route: Route, },
{
path: routes.dashboard_app_order_edit,
      element: <Dashboard_App_Order_Edit />,
      route: Route,
},
{
path: routes.dashboard_app_order_detail,
      element: <Dashboard_App_Order_Detail />,
      route: Route,
},
{
path: routes.dashboard_app_page,
      element: <Dashboard_App_Page />,
      route: Route,
},
{
path: routes.dashboard_app_page_edit,
      element: <Dashboard_App_Page_Edit />,
      route: Route,
},
{
path: routes.dashboard_app_product,
      element: <Dashboard_App_Product />,
      route: Route,
},
{
path: routes.dashboard_app_product_edit,
      element: <Dashboard_App_Product_Edit />,
      route: Route,
},
{
path: routes.dashboard_app_review,
      element: <Dashboard_App_Review />,
      route: Route,
},
{
path: routes.dashboard_app_service,
      element: <Dashboard_App_Service />,
      route: Route,
},
{
path: routes.dashboard_app_service_edit,
      element: <Dashboard_App_Service_Edit />,
      route: Route,
},
{
path: routes.dashboard_app_template,
      element: <Dashboard_App_Template />,
      route: Route,
},
{
path: routes.dashboard_app_template_edit,
      element: <Dashboard_App_Template_Edit />,
      route: Route,
},
{
path: routes.dashboard_app_type,
      element: <Dashboard_App_Type />,
      route: Route,
},
{
path: routes.dashboard_app_type_edit,
      element: <Dashboard_App_Type_Edit />,
      route: Route,
},
// dashboard-app - end

// dashboard-user - start
{
path: routes.dashboard_user_app,
      element: <Dashboard_User_App />,
      route: Route,
},
{
path: routes.dashboard_user_app_detail,
      element: <Dashboard_User_App_Detail />,
      route: Route,
},
/*
{
path: routes.dashboard_user_stat,
      element: <Dashboard_User_Stat />,
      route: Route,
},
*/
{
path: routes.dashboard_user_favorite,
      element: <Dashboard_User_Favorite />,
      route: Route,
},
{
path: routes.dashboard_user_home,
      element: <Dashboard_User_Home />,
      route: Route,
},
{
path: routes.dashboard_user_profile_detail,
      element: <Dashboard_User_Profile_Detail />,
      route: Route,
},
{
path: routes.dashboard_user_profile_edit,
      element: <Dashboard_User_Profile_Edit />,
      route: Route,
},
{
path: routes.dashboard_user_support,
      element: <Dashboard_User_Support />,
      route: Route,
},
{
path: routes.dashboard_user_review,
      element: <Dashboard_User_Review />,
      route: Route,
},
{
path: routes.dashboard_user_order,
      element: <Dashboard_User_Order />,
      route: Route,
},
{
path: routes.dashboard_user_order_detail,
      element: <Dashboard_User_Order_Detail />,
      route: Route,
},
// dashboard-user - end

// dashboard-admin - start
{
path: routes.dashboard_admin_app,
      element: <Dashboard_Admin_App />,
      route: Route,
},
{
path: routes.dashboard_admin_app_detail,
      element: <Dashboard_Admin_App_Detail />,
      route: Route,
},
{
path: routes.dashboard_admin_cart,
      element: <Dashboard_Admin_Cart />,
      route: Route,
},
{
path: routes.dashboard_admin_cart_detail,
      element: <Dashboard_Admin_Cart_Detail />,
      route: Route,
},
{
path: routes.dashboard_admin_order,
      element: <Dashboard_Admin_Order />,
      route: Route,
},
{
path: routes.dashboard_admin_order_detail,
      element: <Dashboard_Admin_Order_Detail />,
      route: Route,
},
{
path: routes.dashboard_admin_favorite,
      element: <Dashboard_Admin_Favorite />,
      route: Route,
},
{
path: routes.dashboard_admin_home,
      element: <Dashboard_Admin_Home />,
      route: Route,
},
{
path: routes.dashboard_admin_user,
      element: <Dashboard_Admin_User />,
      route: Route,
},
{
path: routes.dashboard_admin_review,
      element: <Dashboard_Admin_Review />,
      route: Route,
},
{
path: routes.dashboard_admin_stat,
      element: <Dashboard_Admin_Stat />,
      route: Route,
},
{
path: routes.dashboard_admin_user_detail,
      element: <Dashboard_Admin_User_Detail />,
      route: Route,
},
{
path: routes.dashboard_admin_user_edit,
      element: <Dashboard_Admin_User_Edit />,
      route: Route,
},
// dashboard-admin - end

]

